import {BaseContainerModel} from '../../base-container.model';

export class PreSignedFileContainerModel extends BaseContainerModel {
  url_keys: string[] = [];
}
